export const links = {
  OPEN_TOFU: {
    ROOT: 'https://opentofu.org/',
    COMMANDS: {
      TEST: 'https://opentofu.org/docs/cli/commands/test/'
    },
    DOCS: 'https://docs.envzero.com/docs/modules-continuous-integration-testing'
  },
  CONTACT_US: 'https://www.env0.com/contact',
  SALES_EMAIL: 'sales@env0.com',
  legal: {
    TERMS: 'https://www.env0.com/terms-and-conditions',
    PRIVACY: 'https://www.env0.com/envzero-privacy-policy'
  },
  DEMO: {
    SCHEDULE_DEMO: 'https://meetings.env0.com/meetings/env0/bookdemo'
  },
  docs: {
    ROOT: 'https://docs.envzero.com',
    DEPLOYMENT_CREDENTIALS: {
      CONNECT_CLOUD_ACCOUNT: 'https://docs.envzero.com/docs/connect-your-cloud-account',
      CREATE_AWS_ROLE: 'https://docs.envzero.com/docs/connect-your-cloud-account#create-an-aws-iam-role',
      AWS_ACCESS_KEY_DOCS:
        'https://docs.aws.amazon.com/general/latest/gr/aws-sec-cred-types.html#access-keys-and-secret-access-keys',
      AWS_OIDC_DOCS: 'https://docs.envzero.com/docs/oidc-with-aws',
      GCP_SERVICE_ACCOUNT_DOCS:
        'https://cloud.google.com/iam/docs/creating-managing-service-account-keys#creating_service_account_keys',
      GCP_OIDC_DOCS: 'https://docs.envzero.com/docs/oidc-with-google-cloud-platform',
      AZURE_OIDC_DOCS: 'https://docs.envzero.com/docs/oidc-with-azure',
      AZURE_SERVICE_PRINCIPAL_DOCS: 'https://docs.envzero.com/docs/connect-your-cloud-account#azure',
      K8S: 'https://docs.envzero.com/docs/connect-your-cloud-account#kubernetes',
      K8S_KUBECONFIG_AUTH: 'https://docs.envzero.com/docs/connect-your-cloud-account#kubeconfig',
      K8S_EKS_AUTH: 'https://docs.envzero.com/docs/connect-your-cloud-account#aws-eks',
      K8S_AKS_AUTH: 'https://docs.envzero.com/docs/connect-your-cloud-account#azure-aks',
      K8S_GKE_AUTH: 'https://docs.envzero.com/docs/connect-your-cloud-account#gcp-gke',
      VAULT_OIDC_DOCS: 'https://docs.envzero.com/docs/oidc-with-vault',
      OIDC_V2_TOKEN_DOCS: 'https://docs.envzero.com/docs/oidc#token-versions-v2-per-provider-audience-and-v1-legacy',
      OCI_API_KEY_DOCS: 'https://docs.envzero.com/docs/connect-your-cloud-account#oracle-cloud-infrastructure-oci'
    },
    ENABLING_COST_MONITORING: {
      ROOT: 'https://docs.envzero.com/docs/cost-monitoring',
      CREATE_AWS_IAM_POLICY_ROLE: 'https://docs.envzero.com/docs/aws-costs',
      CREATE_GOOGLE_CREDENTIALS: 'https://docs.envzero.com/docs/gcp-costs',
      CREATE_AZURE_CREDENTIALS: 'https://docs.envzero.com/docs/setup-azure-costs',
      EXPORT_GOOGLE_BILLING_TO_BIGQUERY:
        'https://docs.envzero.com/docs/gcp-costs#section-export-project-billing-data-into-bigquery',
      AWS_GRANULARITY: 'https://docs.envzero.com/docs/aws-costs#enable-hourly-and-resource-level-data',
      BUDGET_NOTIFICATIONS: 'https://docs.envzero.com/docs/budget-notifications'
    },
    PROJECTS: {
      ROOT: 'https://docs.envzero.com/docs/projects'
    },
    DASHBOARDS: {
      ROOT: 'https://docs.envzero.com/docs/dashboards'
    },
    POLICIES: {
      ROOT: 'https://docs.envzero.com/docs/policies',
      ENVIRONMENT_LIMITS: 'https://docs.envzero.com/docs/environment-limits',
      SKIP_REDUNDANT_DEPLOYMENTS: 'https://docs.envzero.com/docs/skip-redundant-deployments',
      SKIP_PR_PLAN_ON_MERGE_COMMITS: 'https://docs.envzero.com/docs/skip-pr-plan-on-merge-commits',
      RUN_PR_COMMENTS_COMMANDS_USING_ALIAS:
        'https://docs.envzero.com/docs/plan-and-apply-from-pr-comments#configuration',
      RUN_PR_COMMENTS_COMMANDS_MAP_VCS_PROVIDER_USER:
        'https://docs.envzero.com/docs/plan-and-apply-from-pr-comments#map-vcs-provider-user',
      RUN_PR_COMMENT_COMMANDS_ENFORCE_PR_COMMENTER_PERMISSIONS:
        'https://docs.envzero.com/docs/plan-and-apply-from-pr-comments#enforce-pr-commenter-permissions-on-env0',
      COST_ESTIMATION: 'https://docs.envzero.com/docs/cost-estimation',
      ENVIRONMENT_OUTPUTS: 'https://docs.envzero.com/docs/environment-outputs',
      OIDC_INTEGRATIONS: 'https://docs.envzero.com/docs/oidc-integrations',
      APPROVAL_POLICIES: 'https://docs.envzero.com/docs/approval-policies',
      POLICY_CATALOG: 'https://docs.envzero.com/docs/policy-catalog',
      ALLOW_ENV0_SECRETS: 'https://docs.envzero.com/docs/allow-env0-secrets',
      REQUIRE_APPROVAL_FOR_PR_APPLIES:
        'https://docs.envzero.com/docs/plan-and-apply-from-pr-comments#require-approval-for-pr-comment-applies',
      BYPASS_APPLY_MERGEABILITY: 'https://docs.envzero.com/guides/policies-governance/bypass-apply-mergeability-check'
    },
    ENVIRONMENTS: {
      ROOT: 'https://docs.envzero.com/docs/environments',
      WORKFLOW_TRIGGERS: 'https://docs.envzero.com/docs/workflow-triggers',
      CREATE_NEW_ENVIRONMENT: 'https://docs.envzero.com/docs/setting-up-a-new-environment',
      CREATE_NEW_WORKFLOW: 'https://docs.envzero.com/docs/create-a-new-workflow',
      TARGETED_DEPLOYMENTS: 'https://docs.envzero.com/docs/targeted-deployments',
      CONFIGURATION_SETS: 'https://docs.envzero.com/docs/variable-sets',
      MOVE_ENVIRONMENT: 'https://docs.envzero.com/docs/move-environment'
    },
    TEMPLATES: {
      ROOT: 'https://docs.envzero.com/docs/templates',
      MANAGE_GIT_CONNECTIVITY: 'https://docs.envzero.com/docs/templates#section-manage-git-connectivity',
      CUSTOM_FLOWS: 'https://docs.envzero.com/docs/custom-flows',
      PROJECT_LEVEL_CUSTOM_FLOWS: 'https://docs.envzero.com/docs/project-level-custom-flow',
      TOKENS: 'https://docs.envzero.com/docs/templates#section--tokens-http-s-',
      GITHUB_INTEGRATION: 'https://docs.envzero.com/docs/github-templates',
      BITBUCKET_SERVER_INTEGRATION: 'https://docs.envzero.com/docs/bitbucket-server-integration',
      GITLAB_EE_INTEGRATION: 'https://docs.envzero.com/docs/gitlab-enterprise-integration',
      GITHUB_ENTERPRISE_INTEGRATION: 'https://docs.envzero.com/docs/github-enterprise-integration',
      AZURE_DEVOPS: 'https://docs.envzero.com/docs/azure-devops-integration'
    },
    MODULES: {
      ROOT: 'https://docs.envzero.com/docs/modules',
      TESTING: 'https://docs.envzero.com/docs/modules-continuous-integration-testing',
      AUTHORIZATION: 'https://docs.envzero.com/docs/private-registry#authorization'
    },
    PROVIDERS: {
      ROOT: 'https://docs.envzero.com/docs/providers',
      CREATE_PROVIDER: 'https://docs.envzero.com/docs/providers#creating-a-provider'
    },
    VARIABLES: {
      VARIABLES_AND_SCOPES: 'https://docs.envzero.com/docs/variables#section-variables-and-scopes-in-env0',
      ENVIRONMENT_OUTPUTS: 'https://docs.envzero.com/docs/environment-outputs#environment-outputs-activation'
    },
    USER: {
      USER_MANAGEMENT: 'https://docs.envzero.com/docs/user-management',
      PROJECT_ROLES: 'https://docs.envzero.com/docs/user-management#manage-users-of-a-project',
      CUSTOM_ROLE_PERMISSIONS: 'https://docs.envzero.com/docs/rbac#custom-role-permissions'
    },
    CONFIGURATION: {
      VARIABLES: 'https://www.terraform.io/docs/configuration/variables.html'
    },
    SCHEDULING: {
      ROOT: 'https://docs.envzero.com/docs/scheduling'
    },
    ENVIRONMENT_DISCOVERY: {
      ROOT: 'https://docs.envzero.com/docs/environment-discovery'
    },
    DRIFT_DETECTION: {
      ROOT: 'https://docs.envzero.com/docs/drift-detection',
      DRIFT_CAUSE: 'https://docs.envzero.com/docs/drift-cause',
      DRIFT_CAUSES: {
        unmanagedChange: 'https://docs.envzero.com/docs/drift-cause#unmanaged-change',
        providerVersionChange: 'https://docs.envzero.com/docs/drift-cause#provider-version-change',
        moduleVersionChange: 'https://docs.envzero.com/docs/drift-cause#module-version-change',
        variableChange: 'https://docs.envzero.com/docs/drift-cause#variable-change',
        unappliedCommit: 'https://docs.envzero.com/docs/drift-cause#unapplied-commit',
        stateChange: 'https://docs.envzero.com/docs/drift-cause#state-modified'
      },
      AUTOMATIC_DRIFT_REMEDIATION: 'https://docs.envzero.com/docs/automatic-drift-remediation',
      DRIFT_ACTIONS: 'https://docs.envzero.com/guides/admin-guide/environments/drift-detection/drift-actions'
    },
    TEAMS: {
      ROOT: 'https://docs.envzero.com/docs/teams'
    },
    CONTROL: {
      TERRAFORM_VERSION: 'https://docs.envzero.com/docs/additional-controls#specify-terraform-version',
      SKIP_GET_WORKING_DIRECTORY: 'https://docs.envzero.com/docs/additional-controls#skip-get-working-directory'
    },
    NOTIFICATIONS: {
      SLACK: 'https://docs.envzero.com/docs/notifications'
    },
    AGENTS: {
      ROOT: 'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent',
      SELF_HOSTED_LOGS:
        'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/hosting-the-deployment-logs',
      SELF_HOSTED_LOGS_TERRAFORM_MODULE: 'https://github.com/env0/k8s-modules/tree/main/log-storage/aws/dynamodb',
      HELM: 'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/self-hosted-kubernetes-agent',
      DOCKER: 'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/standalone-docker-agent',
      MONITORING:
        'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/self-hosted-agents-monitoring',
      MULTIPLE_AGENTS:
        'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/multiple-self-hosted-agents',
      CUSTOM_CONFIG:
        'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/custom-optional-configuration',
      AWS_AUTH:
        'https://docs.envzero.com/guides/admin-guide/self-hosted-kubernetes-agent/authenticating-the-agent-on-aws-eks'
    },
    CONTINUOUS_DEPLOYMENT: {
      CUSTOM_GLOB: 'https://docs.envzero.com/docs/continuous-deployment'
    },
    CHANGE_LOG: {
      INDEX: 'https://docs.envzero.com/changelogs',
      RSS_FEED: 'https://docs.envzero.com/changelog.rss'
    },
    TASK_DEPLOYMENT: 'https://docs.envzero.com/docs/ad-hoc-tasks',
    REMOTE_BACKEND: {
      ROOT: 'https://docs.envzero.com/docs/remote-backend',
      LOGIN: 'https://docs.envzero.com/docs/login',
      REMOTE_APPLY: 'https://docs.envzero.com/docs/remote-apply',
      STATE_MIGRATION: 'https://docs.envzero.com/docs/state-migration'
    },
    AUDIT_LOGS: {
      ROOT: 'https://docs.envzero.com/docs/audit-logs'
    },
    RBAC: {
      ROOT: 'https://docs.envzero.com/docs/rbac'
    },
    ENVIRONMENT_LOCKING: {
      ROOT: 'https://docs.envzero.com/docs/environment-locking'
    },
    BILLING: {
      ROOT: 'https://docs.envzero.com/docs/tiers'
    },
    BULK_OPERATIONS: {
      ROOT: 'https://docs.envzero.com/docs/bulk-operations'
    },
    ENVIRONMENT_IMPORT: {
      DOWNLOAD: 'https://docs.envzero.com/docs/environment-import-1'
    },
    ANSIBLE_DOCS: {
      ANSIBLE_STEPS: 'https://docs.envzero.com/docs/ansible#execution-steps'
    },
    MIGRATION: {
      GUIDE: 'https://docs.envzero.com/docs/tfc-migration'
    }
  },
  TFC: {
    TOKENS: 'https://app.terraform.io/app/settings/tokens'
  },
  CONTACT: {
    MAIL_FOR_TEAMS: 'mailto:team@env0.com?subject=Interested in Adding Teams To My Account'
  },
  AWS: {
    EXTERNAL_ID_DOCS: 'https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-quotas.html'
  },
  GITHUB: {
    env0: {
      HTTPS_BLUEPRINTS: 'https://github.com/env0/blueprints.git',
      SSH_BLUEPRINTS: 'git@github.com:env0/blueprints.git'
    }
  },
  BITBUCKET_SERVER: {
    WEBHOOK_SECRET_DOCS:
      'https://confluence.atlassian.com/bitbucketserver/manage-webhooks-938025878.html#Managewebhooks-webhooksecretsWebhooksecrets'
  },
  GITLAB_EE: {
    WEBHOOK_SECRET_DOCS: 'https://docs.gitlab.com/ee/user/project/integrations/webhooks.html#secret-token'
  },
  GITHUB_ENTERPRISE: {
    WEBHOOK_SECRET_DOCS: 'https://docs.github.com/en/developers/webhooks-and-events/webhooks/securing-your-webhooks'
  },
  CLI: {
    NPM: 'https://www.npmjs.com/package/@env0/cli'
  },
  MCP_SERVER: {
    GITHUB: 'https://github.com/env0/mcp-server'
  },
  TERRAFORM_DOCS: {
    BACKEND_INITIALIZATION: 'https://www.terraform.io/cli/commands/init#backend-initialization'
  },
  PULUMI_DOCS: {
    ENVIRONMENT_DEPLOYMENT: 'https://docs.envzero.com/docs/pulumi#environment-deployment'
  },
  TERRAGRUNT_DOCS: {
    RUN_ALL: 'https://terragrunt.gruntwork.io/docs/features/stacks/#the-run-all-command',
    SUPPORTED_VERSIONS: 'https://terragrunt.gruntwork.io/docs/reference/supported-versions/'
  },
  K8S_DOCS: {
    ENVIRONMENT_DEPLOYMENT: 'https://docs.envzero.com/docs/k8s#environment-deployment',
    K8S_NAMESPACE: 'https://kubernetes.io/docs/tasks/administer-cluster/namespaces-walkthrough/#create-new-namespaces'
  },
  HELM_DOCS: {
    ENVIRONMENT_DEPLOYMENT: 'https://docs.envzero.com/docs/helm#environment-deployment'
  },
  BILLING: {
    CONTACT_US: 'https://www.env0.com/request-meeting',
    TIERS: 'https://docs.envzero.com/docs/tiers',
    AWS_MARKETPLACE: 'https://aws.amazon.com/marketplace/seller-profile?id=55540b66-733b-4d1f-b4fd-84a376407155',
    AZURE_MARKET_PLACE: 'https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=env0&page=1',
    GCP_MARKET_PLACE: 'https://console.cloud.google.com/marketplace/product/env0-public/env0'
  },
  BUDGETS: {
    PROJECT_BUDGET: 'https://docs.envzero.com/docs/budgets#project-budget'
  },
  INTEGRATIONS: {
    PLUGINS: 'https://docs.envzero.com/docs/plugins',
    LOG_FORWARDING: 'https://docs.envzero.com/docs/logs-forwarding',
    IDP: 'https://docs.envzero.com/docs/internal-develoer-platforms',
    SELF_SERVICE_SSO: 'https://docs.envzero.com/guides/sso-integrations/self-service-sso'
  },
  VCS: {
    SELF_HOSTED_VCS: 'https://docs.envzero.com/docs/self-hosted-vcs',
    MANAGE_VCS: 'https://docs.envzero.com/docs/manage-vcs',
    CONNECTIONS_TYPES: 'https://docs.envzero.com/docs/manage-vcs#connection-types'
  },
  CLOUD: {
    INFO: {
      RESOURCES_TABLE: 'https://docs.envzero.com/docs/cloud-compass#assess-resource-breakdown',
      SETTINGS: 'https://docs.envzero.com/docs/cloud-compass#settings',
      TREND: 'https://docs.envzero.com/docs/cloud-compass#view-iac-coverage-trends',
      CURRENT: 'https://docs.envzero.com/docs/cloud-compass#resource-management-type-breakdown',
      SEVERITY: 'https://docs.envzero.com/docs/cloud-compass#evaluating-management-severity'
    },
    REQUIREMENTS: {
      AWS: {
        CLOUD_TRAIL: 'https://docs.envzero.com/docs/configure-cloud-accounts#ensure-active-cloud-trail',
        S3_PERMISSION: 'https://docs.envzero.com/docs/configure-cloud-accounts#grant-bucket-permissions',
        KMS_PERMISSION: 'https://docs.envzero.com/docs/configure-cloud-accounts#grant-decrypt-permission'
      },
      AZURE: {
        LAW_EXPORT:
          'https://docs.envzero.com/docs/configure-an-azure-cloud-account#export-activity-logs-to-an-azure-log-activity-workspace',
        OIDC_PERMISSIONS:
          'https://docs.envzero.com/docs/configure-an-azure-cloud-account#export-activity-logs-to-an-azure-log-activity-workspace'
      },
      GCP: {
        LOGGING_VIEWER_ROLE: 'https://cloud.google.com/logging/docs/access-control#logging.viewer',
        WORKLOAD_IDENTITY_POOL_AND_PROVIDER:
          'https://docs.envzero.com/docs/oidc-with-google-cloud-platform#workload-identity-federation-pool-and-provider'
      }
    }
  },
  CLOUD_ANALYST: {
    ROOT: 'https://docs.envzero.com/docs/cloud-analyst',
    INSIGHTS: 'https://docs.envzero.com/docs/insights',
    DASHBOARDS: 'https://docs.envzero.com/docs/dashboards-1'
  }
};
